export default __webpack_public_path__ + "static/media/testBank.7579c669.jpg";